var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("cms-view", [
    _vm.action
      ? _c(
          "div",
          [
            _c(
              "cms-heading",
              { attrs: { title: _vm.pageTitle } },
              [
                _c(
                  "cms-button",
                  {
                    attrs: {
                      icon: "magicon-pencil",
                      to: {
                        name: "action-edit",
                        params: { id: _vm.action.id },
                      },
                    },
                  },
                  [_vm._v("Wijzigen")]
                ),
                _vm.action.state == "PENDING"
                  ? _c(
                      "cms-button",
                      {
                        attrs: { color: "warning", loading: _vm.updatingState },
                        on: { click: _vm.markInProcess },
                      },
                      [_vm._v("Ingepland")]
                    )
                  : _vm._e(),
                _vm.action.state == "IN_PROCESS"
                  ? _c(
                      "cms-button",
                      {
                        attrs: {
                          icon: "magicon-ok",
                          color: "highlight-2",
                          loading: _vm.updatingState,
                        },
                        on: { click: _vm.markResolved },
                      },
                      [_vm._v("Afgehandeld door veldmedewerker")]
                    )
                  : _vm._e(),
                _vm.action.state == "RESOLVED" && _vm.userIsAdmin
                  ? _c(
                      "cms-button",
                      {
                        attrs: {
                          icon: "magicon-ok",
                          color: "positive",
                          loading: _vm.updatingState,
                        },
                        on: { click: _vm.markClosed },
                      },
                      [_vm._v("Afsluiten")]
                    )
                  : _vm._e(),
                _vm.action.state == "ON_HOLD"
                  ? _c(
                      "cms-button",
                      {
                        attrs: { color: "notice", loading: _vm.updatingState },
                        on: { click: _vm.markPending },
                      },
                      [_vm._v("Openen")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("cms-view-panel", [
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Status actie")]),
                _c(
                  "td",
                  [
                    _c("cms-text-label", {
                      attrs: {
                        title: _vm._f("actionState")(_vm.action.state),
                        color: _vm._f("actionStateColor")(_vm.action.state),
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Logger")]),
                _c(
                  "td",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "logger-view",
                            params: { id: _vm.action.logger.id },
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.action.logger.serialNumber))]
                    ),
                    _vm._v(" (" + _vm._s(_vm.action.logger.type.title) + ")"),
                  ],
                  1
                ),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Status logger")]),
                _c(
                  "td",
                  [
                    _c("cms-text-label", {
                      attrs: {
                        title: _vm._f("loggerState")(_vm.action.logger.state),
                        color: _vm._f("loggerStateColor")(
                          _vm.action.logger.state
                        ),
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Project")]),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.action.project.title) +
                      " (" +
                      _vm._s(_vm.action.project.code) +
                      ")"
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Aanvrager actie")]),
                _vm.action.user
                  ? _c("td", [_vm._v(_vm._s(_vm.action.user.initials))])
                  : _c("td", [_vm._v("-")]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Projectleider")]),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm._f("empty")(_vm.action.project.projectManager))
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Locatie project")]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.action.project.locationManual ||
                        _vm.action.project.locationTitle
                    )
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Meetpunt")]),
                _c("td", [_vm._v(_vm._s(_vm.action.measuringPoint))]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Locatie WWD")]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("empty")(_vm.action.locationTitle))),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Meetfrequentie")]),
                _c("td", [_vm._v(_vm._s(_vm.action.measuringFrequency))]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Zendfrequentie")]),
                _c("td", [_vm._v(_vm._s(_vm.action.transmissionFrequency))]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [
                  _vm._v("Categorieën kantoor"),
                ]),
                _c("td", [_vm._v(_vm._s(_vm.categories))]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [
                  _vm._v("Opmerkingen kantoor"),
                ]),
                _c("td", [_vm._v(_vm._s(_vm.action.commentsOffice))]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Categorieën veld")]),
                _c("td", [_vm._v(_vm._s(_vm.categoriesField))]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Opmerkingen veld")]),
                _c("td", [_vm._v(_vm._s(_vm.action.commentsField))]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [
                  _vm._v("Datum van probleem"),
                ]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(_vm.action.issueDate, "LL"))),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "key" }, [_vm._v("Deadline")]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("date")(
                        _vm._f("actionDeadlineDate")(
                          _vm.action.deadline,
                          _vm.action.issueDate
                        ),
                        "LL"
                      )
                    )
                  ),
                ]),
              ]),
            ]),
            _vm.action.state == "IN_PROCESS"
              ? [
                  _c("cms-heading", {
                    attrs: { level: "2", title: "Logger acties" },
                  }),
                  _c("logger-action-grid", {
                    attrs: {
                      loggers: [_vm.action.logger],
                      "action-mode": true,
                    },
                    on: { executed: _vm.onActionExecuted },
                  }),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }